import { useLocation } from "react-router";

import { Badge } from "@/components/ui/badge";
import { findNavItemByPath } from "../navigation/navConfig";

/**
 * Controlled placeholder for modules on the roadmap but not yet built.
 * Honest by design: no fake functionality, no dead controls.
 */
export const ComingSoon = () => {
  const location = useLocation();
  const navItem = findNavItemByPath(location.pathname);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        {navItem ? (
          <div className="flex size-11 items-center justify-center rounded-lg border border-border bg-surface-muted">
            <navItem.icon
              className="size-5 text-muted-foreground"
              strokeWidth={1.75}
            />
          </div>
        ) : null}
        <h2 className="text-lg font-semibold tracking-tight text-foreground">
          {navItem?.label ?? "This module"} is coming soon
        </h2>
        <p className="text-[13px] leading-relaxed text-muted-foreground">
          This part of Gravun is on the roadmap and hasn't shipped yet. It will
          arrive with {navItem?.milestone ?? "an upcoming milestone"}, see the
          roadmap for sequencing.
        </p>
        {navItem?.milestone ? (
          <Badge
            variant="outline"
            className="rounded-md border-border text-[11px] font-medium text-muted-foreground"
          >
            {navItem.milestone}
          </Badge>
        ) : null}
      </div>
    </div>
  );
};
